const Handlebars = require("@cirrus/legacy/vendor-bower/handlebars/handlebars")

var getLogoUrl = require("@cirrus/legacy/app-common/utils/logoUrlHelper.es6").getLogoUrl

var getStatusBox = require("@cirrus/legacy/app-common/utils/getStatusBox.es6").default

Handlebars.registerHelper("txt", function (input) {
  if (!input) return ""
  var parts = input.split(":")
  var ns = parts[0]
  var key = parts[1]
  return App.Text.get(key, ns)
})
Handlebars.registerHelper("hardcoded", function (input) {
  return input
})
Handlebars.registerHelper("format", function () {
  var format = require("@cirrus/legacy/app-common/utils/text").format

  var text = format.apply(null, arguments)
  return new Handlebars.SafeString(text)
})
Handlebars.registerHelper("formatLocalized", function (combinedKey) {
  var parts = combinedKey.split(":")
  var ns = parts[0]
  var key = parts[1]
  arguments[0] = App.Text.get(key, ns)

  var format = require("@cirrus/legacy/app-common/utils/text").format

  var text = format.apply(null, arguments)

  var utils = require("@cirrus/legacy/app-common/utils/utils.es6").default

  return new Handlebars.SafeString(utils.cleanString(text))
})
Handlebars.registerHelper("formatLocalizedFull", function (combinedKey) {
  arguments[0] = Handlebars.helpers.txt(combinedKey)

  var format = require("@cirrus/legacy/app-common/utils/text").format

  var text = format.apply(null, arguments)

  var utils = require("@cirrus/legacy/app-common/utils/utils.es6").default

  return new Handlebars.SafeString(utils.cleanNotificationString(text))
})
Handlebars.registerHelper("unescapeText", function (text) {
  if (text) return new Handlebars.SafeString(text.replace(/(?!\{.*)\\\\(?!.*\})/g, "\\"))
  return ""
})
Handlebars.registerHelper("statusBox", function (input) {
  var result = getStatusBox(input)
  return new Handlebars.SafeString('<span class="' + result.class + '">' + result.text + "</span>")
})
Handlebars.registerHelper("statusBoxNoTranslation", function (input) {
  switch (input) {
    case "Draft":
      return new Handlebars.SafeString(
        '<span class="status-box status-box-draft">' + input + "</span>",
      )

    case "Concept":
      return new Handlebars.SafeString(
        '<span class="status-box status-box-draft">' + input + "</span>",
      )

    default:
      return new Handlebars.SafeString(
        '<span class="status-box status-box-active">' + input + "</span>",
      )
  }
})
Handlebars.registerHelper("ifNumber", function (value, options) {
  var number = Number(value)

  if (value != null && value !== "" && !isNaN(number)) {
    return options.fn(this)
  }
})
Handlebars.registerHelper("logoImage", function (value, options) {
  var url = getLogoUrl()
  var className = value.hash.class
  return new Handlebars.SafeString('<img class="' + className + '" src="' + url + '" />')
})
Handlebars.registerHelper("showMaxScore", function (scoreValue = 0) {
  const score = scoreValue.hash.score
  const translateKey = parseInt(score, 10) === 1 ? "Point" : "Points"
  const translatedText = App.Text.get(translateKey, "General")

  if (score) {
    return new Handlebars.SafeString(`<span class="dl-question_points">
         (${score} ${translatedText})
      </span>`)
  }

  return null
})
